export { isVercelTool } from '../chunk-63G75DJE.js';
//# sourceMappingURL=is-vercel-tool.js.map
//# sourceMappingURL=is-vercel-tool.js.map